import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
import { useDirection } from '~/hooks/i18nHooks';
import direction from '~/utils/direction';

interface Props {
  values: ReactNode[];
  title?: string;
  footer?: string;
}

const UnorderedList: FC<Props> = (props) => {
  const { title, values, footer } = props;
  const dir = useDirection();

  return (
    <Container className="UnorderedList" dir={dir}>
      {title && <div className="UnorderedList-Title">{title}</div>}
      <ul>
        {values.map((item) => (
          <li key={uuid()}>{item}</li>
        ))}
      </ul>
      {footer && <div>{footer}</div>}
    </Container>
  );
};

const Container = styled.div`
  .UnorderedList-Title {
    margin-bottom: 4px;
  }
  ul {
    ${direction.padding.left(16)};
  }
`;

export default UnorderedList;
